"use client";

import React from "react";

import { createSVGIcon } from "./util";

/**
 * @trackcomponent
 */
export const CreditBack = createSVGIcon(
  <>
    <path
      d="M16.07 18.4711L20.5 17.0001C21.0423 16.8393 21.6208 16.849 22.1574 17.0279C22.694 17.2067 23.1627 17.5461 23.5 18.0001C11.271 24.1131 15.228 24.0771 4.5 20.5001L0.5 23.0001"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.5 19H15C15.1463 19.0263 15.2966 19.0201 15.4402 18.982C15.5839 18.9439 15.7174 18.8747 15.8314 18.7793C15.9454 18.684 16.0371 18.5648 16.1001 18.4301C16.163 18.2955 16.1956 18.1486 16.1956 18C16.1956 17.8514 16.163 17.7045 16.1001 17.5699C16.0371 17.4352 15.9454 17.316 15.8314 17.2207C15.7174 17.1253 15.5839 17.0561 15.4402 17.018C15.2966 16.9799 15.1463 16.9737 15 17H12C10.8147 15.7771 9.20204 15.0603 7.5 15H4.5L0.5 17"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.35498 7.149C9.35498 7.9565 9.51403 8.75609 9.82305 9.50212C10.1321 10.2482 10.585 10.926 11.156 11.497C11.727 12.068 12.4048 12.5209 13.1509 12.8299C13.8969 13.139 14.6965 13.298 15.504 13.298C16.3115 13.298 17.1111 13.139 17.8571 12.8299C18.6031 12.5209 19.281 12.068 19.852 11.497C20.423 10.926 20.8759 10.2482 21.1849 9.50212C21.4939 8.75609 21.653 7.9565 21.653 7.149C21.653 6.3415 21.4939 5.54191 21.1849 4.79588C20.8759 4.04985 20.423 3.37199 19.852 2.801C19.281 2.23001 18.6031 1.77708 17.8571 1.46806C17.1111 1.15905 16.3115 1 15.504 1C14.6965 1 13.8969 1.15905 13.1509 1.46806C12.4048 1.77708 11.727 2.23001 11.156 2.801C10.585 3.37199 10.1321 4.04985 9.82305 4.79588C9.51403 5.54191 9.35498 6.3415 9.35498 7.149V7.149Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.504 4V3"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.9999 4H14.9709C14.6594 4.00022 14.3576 4.10884 14.1174 4.30723C13.8771 4.50563 13.7134 4.78143 13.6543 5.08734C13.5951 5.39325 13.6443 5.71019 13.7933 5.98382C13.9423 6.25745 14.1819 6.4707 14.4709 6.587L16.5349 7.413C16.824 7.5293 17.0636 7.74255 17.2126 8.01618C17.3616 8.28981 17.4108 8.60675 17.3516 8.91266C17.2925 9.21857 17.1288 9.49437 16.8885 9.69277C16.6483 9.89116 16.3465 9.99978 16.0349 10H13.9999"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.504 11V10"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>,
  "CreditCard",
  {
    viewBox: "0 0 24 24",
    titleAccess: "CreditBack",
    fill: "none",
    strokeWidth: 1,
  }
);
